<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @change-selected="checkActiveBtnCreateRWO"
                            @get-selected="createOrder"
                            @export="exportItems"
                            @report="showModalReportConfig"
                            ref="gofixTable">
                            <template slot="gofix_table:issue_register_time" slot-scope="row">
                                {{row.item.issue_register_time  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:close_date" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:order_number" slot-scope="row">
                                <span class="checklistLink" @click="gotoOrderNumber(row.item)">{{ row.item.order_number }}</span>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.createOrder.open" ref="modal-Remove">
                <div class="center">Are you sure you want to<br/>create <strong>CWO</strong>?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="$refs['modal-Remove'].hide()">No</b-button>
                    <b-button class="custom-btn" :disabled="modals.createOrder.loading" @click="actionCreateOrder" > <b-spinner v-if="modals.createOrder.loading" small type="grow"></b-spinner> Yes</b-button>
                </b-button-group>
            </b-modal>
            <ModalReportConfig 
                :contract_id="ClientContractID && ClientContractID.id ? ClientContractID.id : null"
                :supplier="modals.reportConfig.supplier"
                :eq_ids="modals.reportConfig.eq_ids"
                v-model="modals.reportConfig.open" 
                @report="liftInspectionReport"/>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const ModalReportConfig = () => import('./ModalReportConfig')
    import moment from 'moment';

    export default {
        name: 'issue-register',
        components: {
            ModalReportConfig
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['issue_register']));
            return {
                tableConfig:{
                    name: 'preventive-maintenance-issue-register',
                    controls:{
                        create: false,
                        delete: false,
                        sendSelected: this.$checkRole(this.$accessModule.order, 'create'),
                        sendSelectedText: "Create CWO",
                        reportPDF: false,
                        titleReportPDF: "Create Report"
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "issue_register_time",
                    sortDirection: "desc",
                },
                tableItems: [],
                loadingDetail: false,
                modals:{
                    createOrder : {
                        open: false,
                        loading: false,
                        ids: []
                    },
                    reportConfig: {
                        open: false,
                        supplier: null,
                        eq_ids: []
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {
            ClientContractID: function(val) {
                this.tableConfig.controls.reportPDF = false;
                if(val && val.settings && val.settings.is_allow_issue_register_show_lift_inspection_report_button){
                    this.tableConfig.controls.reportPDF = true;
                }
            }
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.settings && this.ClientContractID.settings.is_allow_issue_register_show_lift_inspection_report_button){
                this.tableConfig.controls.reportPDF = true;
            }
        },
        methods: {
            gotoOrderNumber (item) {      
                this.loadingDetail = true;
                if(item.order_id){
                    return this.$router.push(`/v2/orders/${item.order_id}`);
                }
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("IssueRegisterController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the issue register", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                if(!this.loadingDetail) {
                    return this.$router.push(`/v2/issue-register/${item.id}`);
                }
            },
            checkActiveBtnCreateRWO(ids) {
                this.issue_register_ids = ids;
                let is_disabled = false;
                if(ids.length) {
                    let itemTemp = this.tableItems.filter(item => ids.includes(item.id))
                    if(itemTemp.length) {
                        let service_category_id = itemTemp[0].service_category_id;
                        this.tableItems.some(item => {
                            if(ids.includes(item.id) && (service_category_id != item.service_category_id || item.status != 'New')) {
                                is_disabled = true;
                                return true;
                            }
                            return false;
                        })
                    } 
                }
                let objTemp = Object.assign(this.tableConfig.controls, {
                    sendSelectedDisabled: is_disabled
                })
                this.tableConfig.controls = JSON.parse(JSON.stringify(objTemp));
            },
            createOrder(ids){
                if(!ids.length){
                    return this.$alertNotification("Please select at least 1 line to create the order!", "danger");
                }
                if(!this.ClientContractID || (this.ClientContractID && !this.ClientContractID.id)) {
                    return this.$alertNotification("Please select Client Contract before create CWO.", "danger");
                }
                this.modals.createOrder.open = true;
                this.modals.createOrder.ids = ids;
            },
            actionCreateOrder(){
                if(this.modals.createOrder.loading) return;
                this.modals.createOrder.loading = true;
                this.$store.dispatch("OrderController/createOrderIssueRegister", {
                    ids: this.modals.createOrder.ids,
                    sla_id: null,
                    order_type: 'Corrective'
                }).then(result => {
                    this.modals.createOrder.loading = false;
                    this.modals.createOrder.open = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    return this.$alertNotification(this.$notificationV2('adding', 'order'));
                })
                .catch(error => {
                    this.modals.createOrder.loading = false;
                    this.modals.createOrder.open = false;
                    if(error.response.data.error && error.response.data.error.message) {
                        return this.$alertNotification(error.response.data.error.message, "danger");
                    }
                })
            },
            exportItems(tableRequest) {
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    return this.$alertNotification("Please choose a contract.", "danger");
                }
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                this.$store.dispatch( 'IssueRegisterController/exportItems', request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'IssueRegisterList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
            showModalReportConfig() {
                if(!this.issue_register_ids || !this.issue_register_ids.length) {
                    return this.$alertNotification('Please select only 1 item to create report.', 'danger');
                }
                /* Check same checklist_id */
                // let trigger = true;
                // this.modals.reportConfig.supplier = null
                // if(this.issue_register_ids.length) {
                //     let itemTemp = this.tableItems.filter(item => this.issue_register_ids.includes(item.id))
                //     if(itemTemp.length) {
                //         let checklist_id = itemTemp[0].checklist_id;
                //         itemTemp.some(item => {
                //             if(checklist_id != item.checklist_id) {
                //                 trigger = false;
                //                 return true;
                //             }
                //             return false;
                //         })

                //         if(!trigger) {
                //             return this.$alertNotification("Checklist_ID doesn't match this ISSUE REGISTER", 'danger');
                //         }

                //         if(itemTemp[0].supplier_id && itemTemp[0].supplier) {
                //             this.modals.reportConfig.supplier = {
                //                 id: itemTemp[0].supplier_id,
                //                 name: itemTemp[0].supplier
                //             }
                //         } 
                //     }
                // }

                // let itemTemp = this.tableItems.filter(item => this.issue_register_ids.includes(item.id) && item.status != 'Sent')
                // if(itemTemp.length != this.issue_register_ids.length) {
                //     return this.$alertNotification("Please only select issue register without Sent status", 'danger');
                // }
                
                let eq_ids = this.tableItems.map((item) => {
                    if(this.issue_register_ids.includes(item.id)) {
                        return item.equipment_id;
                    }
                }).filter(Boolean);

                this.modals.reportConfig.eq_ids = Array.from(new Set(eq_ids))

                this.modals.reportConfig.open = true;
            },
            liftInspectionReport(request = {}) {
                if(request.is_download) request.emails = null
                this.$store.dispatch("LiftInspectionReportController/liftInspectionReport", {
                    ids: this.issue_register_ids,
                    ...request
                })
                .then(response => {
                    if(request.is_download) {
                        let nameFIle = `Lift_Inspection_Report_${moment().format('DD_MMM_YYYY')}.zip`;
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFIle);
                        document.body.appendChild(link);
                        link.click();
                        this.modals.reportConfig.open = false;
                        return;
                    }
                    
                    this.modals.reportConfig.open = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification("Send the defects list report successfully");
                }).catch(err => {
                    if(err.response && err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                });
            }

        }
    }
</script>
